jQuery(document).ready(function($) {

    function throttle(callback, limit) {
        var allowFire = true,
            deadmanTrigger = null; // always fire at the very end

        return function() {

            clearTimeout(deadmanTrigger); // ensure the last triggered function runs after limit is reached
            deadmanTrigger = setTimeout(function() {
                callback.apply(null, arguments);
            }, limit);

            if(allowFire) {
                setTimeout(function() {
                    allowFire = true;
                }, limit);

                allowFire = false;
                callback.apply(null, arguments);
            }
        };
    }

    /**
     * staff member show description button
     */

     var staffProfile = (function(){
         // $('body').on('click', '.staff_member .show_description', function(){
         //     $(this).next('.description').toggleClass('visible');
         //     $(this).toggleClass('active');
         //     $(this).parents('.staff_member').toggleClass('blur');
         //     if($(this).text() == '+'){
         //         $(this).text('-');
         //     }else{
         //         $(this).text('+');
         //     }
         // });
     })();

     (function properlyAlignMobileSubmenus() {
         function realignSubmenus() {
            $('#menu-mobile-menu .sub-menu').each(function() {
                var verticalOffset = $(this).parent().position().top;

                $(this).css('top', -verticalOffset);

            });
         }

         $(window).on('resize ready load', realignSubmenus);

     })();


     (function properlyAlignDesktopSubmenus() {

         function realignSubmenus() {

             var headingWidth = $('#menu-main-navigation').width();

             $('li > .sub-menu-wrapper').each(function() {
                var tdOffset = $(this).parents('li').first().position().left;

                $(this).css('width', headingWidth).css('left', -tdOffset);
             });
         }

         $(window).on('resize ready load', realignSubmenus);

     })();

     $(window).on('resize', function() {
        setTimeout(function() {
            // $(".owl-carousel").trigger('refresh.owl.carousel');
        }, 0);
     });

     (function moveSecondaryNavToTopOnMobile() {
        var secondaryNav = $('.secondary_nav_wrapper').first();
        var content = $('#page-wrapper > .container').first();
        var sidebar = secondaryNav.parents('.sidebar').first();
        var secondaryNavUl = secondaryNav.find('ul');

        function reposition() {
            var secondaryNavHeight = secondaryNav.outerHeight(true);

            content.css('top', secondaryNavHeight); // will only apply when position is relative, leave this to media queries
            sidebar.css('top', -secondaryNavHeight);

            secondaryNav.css('top', content.offset().top - secondaryNav.css('top', '').offset().top - secondaryNavHeight);
        }

        function setDropdownMaxHeight() {
            // secondaryNavUl.parent().css('max-height', '');
            // console.log('secondary nav ul height: %s', secondaryNavUl.outerHeight());

            secondaryNavUl.parent().css('max-height', secondaryNavUl.outerHeight()); // for transitioning to "auto" in dropdown mode
        }

        if(secondaryNav.length) {

            secondaryNav.find('.section_title').on('click', function() {
                secondaryNav.toggleClass('collapsed');
                reposition();
            });

            $(window).on('load ready resize', throttle(setDropdownMaxHeight, 200));
            $(window).on('load ready resize scroll', throttle(reposition, 50));
        }


     })();

     (function makeIframesResponsive() { // used for youtube videos for example
         function responsify(event, iframe) { // event is unusued, adding it allows it to be dropped into event callbacks where the first parameter is always

             if(iframe === undefined) {
                 iframe = this;
             }

             iframe = $(iframe);

             var responsiveIframeClass = 'responsive-iframe';

             if(iframe.parents(responsiveIframeClass).length) {
                 return; // this is already a responsive iframe
             }

             var attrWidth = iframe.attr('width') || iframe.width();
             var attrHeight = iframe.attr('height') || iframe.height();

             // calculate the proper ratio
             var ratio = attrHeight / attrWidth * 100 + '%';

             var container = $('<div>')
                    .addClass(responsiveIframeClass)
                    .css('padding-bottom', ratio);

             iframe.wrap(container);

             return container;
         }

         $('iframe').each(responsify);
     })();


     (function fixVerticalAlignmentOnCenteredColumns() {
         function recalculateTop() { // this is needed to eliminate the html whitespace vertical offset caused by display inline / display inline block (alternative is to elimiminate all whitespace around cols)

             $('.literature_section .col').each(function() {
                 if($(this).parent().find('> .col').length > 2) return;

                 $(this).css('top', '').css('top', -$(this).position().top);
             });
         }

         $(window).on('resize', throttle(recalculateTop, 100));
         recalculateTop();

         $('.literature_section .col article').matchHeight();

     })();

     var openSearch = (function() {
         $('body').on('click', '.button.search a', function() {
             $(this).parent().toggleClass('active');
             $('#search-input-wrapper').toggleClass('open');
         });
     })();

     var homepageSlideshow = (function(){

         $("#homepage-slideshow .image-slideshow").owlCarousel({
                loop: true,
                nav: false,
                autoplay: true,
                autoplayTimeout: 8000,
                autoplaySpeed: 1000,
                items: 1,
                autoplayHoverPause: true
          });

          $('onInitialize.owl', function() {

              $('.owl-dots').wrap('<div class="owl-dots-wrapper"></div>');

          });
     })();


     var storiesCarousel = (function(){

         $('.stories_carousel').owlCarousel({
             loop: true,
             nav: true,
             autoplay: true,
             autoplayTimeout: 5000,
             autoplaySpeed: 1500,
             slideBy: 2,
             autoplayHoverPause: true,
             responsive: {
                 0: {
                     items: 1
                 },
                 480: {
                     items: 2
                 },
                 700: {
                     items: 3
                 },
                 980: {
                     items: 4
                 }
             }
         });

     })();


$('.icon-linee').clone().addClass('links-carousel').appendTo("#ahec-pipeline");
$('.links-carousel').removeClass('row');
$('.links-carousel').hide();
     if (window.matchMedia('(max-width: 980px)').matches) {
         $('.icon-linee').hide();
         $('.mobile-links-carousel').removeClass('col-xs-12 col-sm-6 col-md-4');
         $('.links-carousel').show();
              var linksCarousel = (function(){

                  $('.links-carousel').owlCarousel({
                      loop: true,
                      nav: true,
                      autoplay: false,
                      slideBy: 2,
                      autoplayHoverPause: true,
                      nestedItemSelector: 'service-group',
                      responsive: {
                          0: {
                              items: 1
                          }
                      }
                  });

              })();
     }

     $(window).resize(function() {
         if (window.matchMedia('(max-width: 980px)').matches) {


             $('.icon-linee').hide();
             $('.mobile-links-carousel').removeClass('col-xs-12 col-sm-6 col-md-4');
             $('.links-carousel').show();
                  var linksCarousel = (function(){

                      $('.links-carousel').owlCarousel({
                          loop: true,
                          nav: true,
                          autoplay: false,
                          slideBy: 2,
                          autoplayHoverPause: true,
                          nestedItemSelector: 'service-group',
                          responsive: {
                              0: {
                                  items: 1
                              }
                          }
                      });

                  })();
         } else {
             $('.icon-linee').show();
             $('.links-carousel').hide();
             $('.mobile-links-carousel').addClass('col-xs-12 col-sm-6 col-md-4');
         }
     });

     var setActiveInputsClass = (function() {

		$('input').each(function() {

			if ($(this).val() !== '') {
				$(this).closest('.form-group').addClass('input_filled');
			}
		});

		$('body').on('focus', 'input', function() {
			$(this).closest('.form-group').addClass('input_focus');
		});

		$('body').on('blur', 'input', function() {

			var parent = $(this).closest('.form-group');

			parent.removeClass('input_focus');

			if ($(this).val() !== '') {
				parent.addClass('input_filled');
			}
			else {
				parent.removeClass('input_filled');
			}
		});

	})();

	var raTabs = (function() {

		$('body').on('click', '.tabs_list label', function() {
			$('.tabs_list label').removeClass('active').attr('aria-selected', 'false');

			$(this).addClass('active').attr('aria-selected', 'true');
		});

		$('body').on('change', '.tabs_wrapper input[type="radio"]', function(){

			$('.tabs_wrapper input[type="radio"]').siblings('.tabpanel').attr('aria-hidden', 'true');
			$(this).siblings('.tabpanel').attr('aria-hidden', 'false');

		});
	})();

	var raAccordions = (function(){
		$('body').on('change', '.accordion_wrapper input[type="checkbox"]', function(){
			var id = $(this).attr('id');

			if($(this).is(':checked')) {
				$('label[for="' + id + '"]').attr('aria-selected', true);
				$(this).siblings('.content_wrapper').find('.content').attr('aria-hidden', 'false');
			} else {
				$('label[for="' + id + '"]').attr('aria-selected', false);
				$(this).siblings('.content_wrapper').find('.content').attr('aria-hidden', 'true');
			}

		});
	})();

	var accessibleForms = (function() {
		$('body').on('change', 'input[type="checkbox"][role="checkbox"]', function(){
			if($(this).is(':checked')) {
				$(this).attr('aria-checked', 'true');
			} else {
				$(this).attr('aria-checked', 'false');
			}
		});

		$('body').on('change', 'input[type="radio"][role="radio"]', function(){

			var name = $(this).attr('name');

			$('input[type="radio"][name="' + name + '"]').attr('aria-checked', false);
			$(this).attr('aria-checked', true);

		});
	})();

    var accessibleMenus = (function() {

        $('#main-nav').find('.sub-menu-wrapper').each(function(){
            var parentId = $(this).closest('.menu-item').attr('id');

            $(this).closest('.menu-item').attr('aria-haspopup', 'true').attr('aria-expanded', 'true').attr('aria-owns', parentId + '-submenu').attr('aria-controls', parentId + '-submenu');

            $(this).attr('role', 'group').attr('aria-hidden', 'true').attr('aria-expanded', 'false').attr('id', parentId + '-submenu').attr('aria-labelledby', parentId);

        });

        $('.sub-menu').on('focus', 'a', function() {
            $(this).closest('.sub-menu-wrapper').attr('aria-hidden', 'false').attr('aria-expanded', 'true').closest('.menu-item').addClass('active');
        });

        $('.sub-menu').on('blur', 'a', function() {
            $(this).closest('.sub-menu-wrapper').attr('aria-hidden', 'true').attr('aria-expanded', 'false').closest('.menu-item').removeClass('active');
        });

    })();

    //faqs accordion
    $('.fax').click(function(e) {
        e.preventDefault();

        if($(this).next('div').is(':visible')){
            $(this).next('.showcase_secondary_dropdown').slideUp('fast');
            $('.showcase_secondary_dropdown_link strong span').removeClass('expanded');
        }

        else {

        $('.showcase_secondary_dropdown').slideUp('fast');
        $('.showcase_secondary_dropdown_link strong span').removeClass('expanded');

        $(this).find('span').toggleClass('expanded');
        $(this).next('.showcase_secondary_dropdown').slideToggle('fast');
        }

    });

    $('.faq_handle').click(function(e){
        e.preventDefault();

         if($(this).next('div').is(':visible')) {
            $(this).removeClass('open');
            $(this).next('div').slideUp(200);
         }

        else {

            $('.faq_item .faq_handle').removeClass('open');
            $('.faq_item div').slideUp(200);

            $(this).addClass('open');
            $(this).next('div').slideToggle(200);
        }
    });


    //cta dropdowns - used in news sidebar

    $('.cta_dropdown > a').click(function(e){
        e.preventDefault();
        //$('.cta_dropdown ul').slideUp(200);
        //$('.cta_dropdown > a').removeClass('open');
        $(this).stop().toggleClass('open');
        $(this).next('ul').stop().slideToggle(200);
    });

    jQuery('.filter_list > li > a').click(function(e){

        if (jQuery(this).hasClass('withsubmenu')) {
            e.preventDefault();
        }

        jQuery('.filter_list ul').slideUp('fast');
        jQuery('.filter_list > li > a').removeClass('active');

        if (jQuery(this).next('ul').is(":hidden")) {
            jQuery(this).addClass('active');
            jQuery(this).next('ul').slideDown('fast');
        }

        else {
            jQuery(this).removeClass('active');
            jQuery(this).next('ul').slideUp('fast');
        }

    });


    // pipleline carousel on homepage
    if($(window).width() > 980){
        pipeline_carousel();
    }

    function pipeline_carousel(){
        $('.pipeline-carousel').owlCarousel({
            loop: true,
            nav: true,
            items: 1
        });
    }

    $(window).resize(function(){
        if($(window).width() > 980) {
            pipeline_carousel();
        }else{
            $('.pipeline-carousel').trigger('destroy.owl.carousel').removeClass('owl-carousel owl-loaded');
            $('.pipeline-carousel').find('.owl-stage-outer').children().unwrap();
        }
    });

    (function highlightErrorsInForms() {
        var invalidFields = $('input[aria-invalid="true"]');

        function checkIfErrorInViewport() {
            var topDistance = $(window).scrollTop();
            var windowHeight = $(window).height();

            invalidFields.each(function() {
                var fieldTop = $(this).offset().top;

                if(fieldTop > topDistance && fieldTop < topDistance + windowHeight) {
                    $(this).addClass('flag-error');
                }
            });
        }

        $(window).on('resize scroll', throttle(checkIfErrorInViewport, 500)); // only check if errors have been scrolled into view every half second
        $(document).on('ready', checkIfErrorInViewport);

    })();


    // Off Canvas Nav
    $('#mobile-trigger').click(function(){
        console.log("test");
        $(this).toggleClass('active');
        if($(this).hasClass('active')){
            $(this).css({
                left: $(window).width()-$(this).width()-42
            });
            $('#off_canvas_menu').animate({opacity: 1}, 350, function(){
                $('#off_canvas_menu').addClass('active');
            });
        }else{
            $('#off_canvas_menu').removeClass('active');
            $('#off_canvas_menu').animate({opacity: 1}, 350, function(){
                $('#mobile-trigger').css({
                    left: $(window).width()-$(this).width()
                });
            });
        }
    });

    $('#off_canvas_menu li.menu-item-has-children .view_submenu').click(function(){
        $('#off_canvas_menu li ul').hide();
        $(this).next('ul').show();
        $('.top_level_menu').addClass('sub_menu_active');
    });

    $('#off_canvas_menu li.back a').click(function(){
        $('.top_level_menu').removeClass('sub_menu_active');
    });


    // force ahec digital library link to open in new window
    $('a[href="https://library.ncahec.net/index.php"]').attr('target', '_blank');


    // vertically center prev/next buttons on explore bar
    // function center_prev_next(){
    //     var height = $('.full_width_secondary_nav .owl-stage-outer .circle_img_frame').height();
    //         $('.owl-nav').css('marginTop', -((height/2)) );
    // }
    //
    // $(window).load(function(){
    //     center_prev_next();
    // });
    //
    // $(window).resize(function(){
    //     center_prev_next();
    // });

    //remove height from images in main content section
    $('.main_content img').each(function(){
        $(this).removeAttr('height');
    });

    $(window).load(function(){
        $('.resource_column').matchHeight();
        $('.resource_text_area').matchHeight();
    });

    //responsive tables
    $('table').each(function(){
        $(this).wrap('<div class="table_container"></div>');
    });

});
